export const isReplica = process.env.REACT_APP_REPLICA === 'yes'
export const API_PATH = isReplica ? "https://api.adadiabeteseducation.com" : "https://api.adagulf.com";

export const STORAGE_TYPE = {
  LOCAL_STORAGE: "localStorage",
  SESSION_STORAGE: "sessionStorage",
};
